export const messageAutomationPreferencesConstants = {
  GET_USER_PREFERENCES_STARTED: 'GET_MESSAGE_AUTOMATION_USER_PREFERENCES_STARTED',
  GET_USER_PREFERENCES_SUCCESS: 'GET_MESSAGE_AUTOMATION_USER_PREFERENCES_SUCCESS',
  GET_USER_PREFERENCES_FAILURE: 'GET_MESSAGE_AUTOMATION_USER_PREFERENCES_FAILURE',

  UPDATE_USER_PREFERENCE_STARTED: 'UPDATE_MESSAGE_AUTOMATION_USER_PREFERENCE_STARTED',
  UPDATE_USER_PREFERENCE_SUCCESS: 'UPDATE_MESSAGE_AUTOMATION_USER_PREFERENCE_SUCCESS',
  UPDATE_USER_PREFERENCE_FAILURE: 'UPDATE_MESSAGE_AUTOMATION_USER_PREFERENCE_FAILURE',
};
